module.exports = __webpack_public_path__ + "img/headset.43a4ba63.png";